import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {NgbModal, NgbModalOptions, NgbModalRef} from "@ng-bootstrap/ng-bootstrap";
import {NgForm} from "@angular/forms";
import {PortfolioService} from "../portfolio/portfolio-service.service";

interface ITechItem {
    technology: string,
    selected: boolean,
    id: string
}

@Component({
    selector: 'ngbd-modal-select-techs',
    templateUrl: './modal-select-techs.component.html',
    styleUrls: ['./modal-select-techs.component.css']
})
export class ModalSelectTechsComponent implements OnInit {
    selectedTechnologies: ITechItem[];
    selectModal: NgbModalRef;
    modalOptions: NgbModalOptions;

    @Output()
    closeResult = new EventEmitter<string[]>();


    constructor(private modalService: NgbModal, private portfolioService: PortfolioService) {
        this.modalOptions = {}
    }

    ngOnInit() {
        this.selectedTechnologies = [];
        this.portfolioService.config.subscribe((config) => {
            let iconData = config['icons'];
            for (let key in iconData) {
                this.selectedTechnologies.push(
                    {
                        id: key,
                        selected: false,
                        technology: iconData[key]
                    }
                )
            }
        });
    }

    open(content) {
        this.selectModal = this.modalService.open(content, this.modalOptions);

        this.selectModal.result.then((result) => {
            this.closeResult.emit(result);
        }, (reason) => {
            this.closeResult.emit([]);
        });
    }

    applySelection(form: NgForm) {
        let selectedKeys: string[] = [];
        for (let key in form.controls) {
            if (form.controls[key].value === true) {
                selectedKeys.push(key);
            }
        }
        this.selectModal.close(selectedKeys);
        this.portfolioService.updateTechlist(selectedKeys);
    }

    clearSelection(form: NgForm) {
        form.resetForm();
    }
}



// WEBPACK FOOTER //
// ./src/app/modal-select-techs/modal-select-techs.component.ts